import { queries } from "lib/build/dashboards/ktx/queries";
import { Status } from "lib/build/forms/ktx/committeeOpinion";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventValueByQuery } from "src/features/events";
import { longStatusMessages } from "src/modules/ktx/messages";

export function useLongStatus(): string | undefined {
	const formatMessage = useFormatMessageMap();
	const status =
		useLastEventValueByQuery<Status>(queries.patientStatus) || Status.NEW;
	return formatMessage(longStatusMessages, status);
}
